import './App.css';
import { Navbar } from './components/Navbar';
import { About } from './components/About';
import { BackgroundAnimation } from './components/Animation';
import { Skills } from './components/Skills';
import { Contact } from './components/Contact';
import { Projects } from './components/Projects';


function App() {
    return (
        <div >
            <Navbar />
            <About />
            <BackgroundAnimation/>
            <Skills />
            <Projects />
            <Contact />
        </div>
    );
};

export default App;
